import { render, staticRenderFns } from "./specialistForm.vue?vue&type=template&id=13a5adeb&"
import script from "./specialistForm.vue?vue&type=script&lang=js&"
export * from "./specialistForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports